import { Radio, RadioGroup } from '../radio';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { LOCALIZED_STRINGS } from './constants';
import { FormattedMessage } from 'react-intl';

class NewExistingRadio extends PureComponent {
    static propTypes = {
        defaultValue: PropTypes.string,
        name: PropTypes.string,
        onClickExistingPatientType: PropTypes.func,
        onClickNewPatientType: PropTypes.func,
        selectPatientStatus: PropTypes.func,
        shortText: PropTypes.bool,
        small: PropTypes.bool,
    };

    static defaultProps = {
        name: 'new-existing-radio',
        small: false,
    };

    render() {
        const {
            defaultValue,
            name,
            onClickExistingPatientType,
            onClickNewPatientType,
            onKeyDownExistingPatientType,
            onKeyDownNewPatientType,
            selectPatientStatus,
            shortText,
            small,
        } = this.props;

        // Small styles: smaller width, flushed/no padding, smaller inner margin
        const StyledRadio = small ? NewExistingPatientRadioSmall : NewExistingPatientRadio;
        const radioProps = small ? {
            innerMargin: 4,
        } : {};

        const StyledRadioGroup = small ? NewExistingRadioGroupSmall : NewExistingRadioGroup;
        const radioGroupProps = small ? {
            flush: true,
            renderWithoutBox: true,
        } : {};

        const newLabelText = shortText ? LOCALIZED_STRINGS.NewPatientSmall :
            LOCALIZED_STRINGS.NewPatient;
        const existingLabelText = shortText ? LOCALIZED_STRINGS.ExistingPatientSmall :
            LOCALIZED_STRINGS.ExistingPatient;

        return (
            <StyledRadioGroup
                {...radioGroupProps}
                data-test="new-existing-radio"
                name={name}
                onChangeCallback={selectPatientStatus}
                orientation="horizontal"
                selectedValue={defaultValue}
            >
                <StyledRadio
                    {...radioProps}
                    dataTestSelector="new-patient-radio"
                    text={<FormattedMessage {...newLabelText} />}
                    trackOnClick={onClickNewPatientType}
                    trackOnKeyDown={onKeyDownNewPatientType}
                    value="new-patient"
                />
                <StyledRadio
                    {...radioProps}
                    dataTestSelector="existing-patient-radio"
                    text={<FormattedMessage {...existingLabelText} />}
                    trackOnClick={onClickExistingPatientType}
                    trackOnKeyDown={onKeyDownExistingPatientType}
                    value="existing-patient"
                />
            </StyledRadioGroup>
        );
    }
}

const NewExistingPatientRadio = styled(Radio)` 
    flex-basis: auto;
`;

const NewExistingPatientRadioSmall = styled(Radio)`
    flex-basis: auto;
    flex-grow: unset;
`;

const NewExistingRadioGroup = styled(RadioGroup)`
    min-width: 160px;
`;

const NewExistingRadioGroupSmall = styled(RadioGroup)`
    width: 88px;
    justify-content: space-between;
`;

export {
    NewExistingRadio as default,
    NewExistingRadio,
};
